import { useEffect, useRef } from 'react';

interface HostCursorPositionSenderParams {
  isEnabled: boolean;
  onSendCursorPosition: (
    xRatio: number,
    yRatio: number,
    slideAspectRatio: number,
  ) => void;
}

const CURSOR_THROTTLE_MS = 16.67;

export const useHostCursorPositionSender = ({
  isEnabled,
  onSendCursorPosition,
}: HostCursorPositionSenderParams) => {
  const lastCursorSendAtRef = useRef<number>(0);
  const isEnabledRef = useRef<boolean>(isEnabled);

  const sendCursorPositionIfThrottled = (
    xRatio: number,
    yRatio: number,
    slideAspectRatio: number,
  ) => {
    if (!isEnabledRef.current) {
      return;
    }

    const now = Date.now();
    if (now - lastCursorSendAtRef.current >= CURSOR_THROTTLE_MS) {
      lastCursorSendAtRef.current = now;
      onSendCursorPosition(xRatio, yRatio, slideAspectRatio);
    }
  };

  useEffect(() => {
    isEnabledRef.current = isEnabled;
  }, [isEnabled]);

  return sendCursorPositionIfThrottled;
};
